module.exports = __webpack_public_path__ + "static/media/contemplar_te_2.d698b34a.jpg";